import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"
import { MarkdownPreview } from "shared/ui/input/markdown/components/MarkdownPreview"

import { PRODUCT_POSITION_TABLE_REMARK_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowRemarkCellProps
  extends ProductPositionRowCellProps {
  remark?: string | null | undefined
}

export const ProductPositionRowRemarkCell = React.memo(
  React.forwardRef(
    (
      { remark, ...rest }: ProductPositionRowRemarkCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const { t } = useTranslation()

      return (
        <ProductPositionTableCell
          ref={ref}
          aria-labelledby={PRODUCT_POSITION_TABLE_REMARK_HEADER_ID}
          className="remark"
          data-testid="remark-cell"
          tooltip={remark ? <MarkdownPreview value={remark} /> : null}
          {...rest}
        >
          <div className="table-row-cell__content">
            {remark ? (
              <Icon name={IconName.COMMENT} size={IconSize.SMALL} />
            ) : (
              <div className="visually-hidden">{t("General.NoRemark")}</div>
            )}
          </div>
        </ProductPositionTableCell>
      )
    }
  )
)
